<template>
  <v-row align="center">
    <v-col :cols="10">
      <v-text-field
        v-model="text"
        hide-details
        outlined
        dense
        :label="label"
        v-on="$listeners"
      />
    </v-col>
    <v-col :cols="2">
      <v-btn icon small :disabled="!text" @click="apply">
        <v-icon color="green" class="ma-2">
          mdi-check
        </v-icon>
      </v-btn>
      <v-btn icon small class="ma-2" @click="close">
        <v-icon color="red">
          mdi-close
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["value", "label"],
  data() {
    return {
      text: "",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.text = val;
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
    apply() {
      this.$emit("apply", this.text);
    },
  },
};
</script>
